import Promise from 'bluebird';
import { doesUserHasPermission } from './utils';
export var removeError = function (statusId) {
    if (statusId) {
        SP.SOD.executeFunc('sp.js', 'SP.UI.Status', function () {
            SP.UI.Status.removeStatus(statusId);
        });
    }
};
var showError = function (exception, adminOnly) {
    if (adminOnly === void 0) { adminOnly = true; }
    return new Promise(function (resolve, reject) {
        return doesUserHasPermission(3).then(function (isAdmin) {
            if (exception) {
                resolve('OK!');
                if (console.error) {
                    console.error(exception);
                }
            }
            else {
                reject('no exception');
            }
        });
    });
};
export var showErrorToUser = function (exception) {
    return showError(exception, false);
};
export default showError;
